import { styled } from '@mui/material/styles';
import { Select, MenuItem } from '@mui/material';

export const StyledSelect = styled(Select)(({ theme }) => ({
  borderRadius: '6px',
  backgroundColor: theme.palette.common.white,
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: theme.customColors.primary10,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.customColors.primary100,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.customColors.primary100,
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px',
    fontWeight: 400,
    paddingRight: '24px',
  },
  '& .MuiSelect-select:focus': {
    backgroundColor: 'transparent',
  },
  '& .MuiInputBase-input:focus': {
    outline: 'none',
  },
}));

export const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '10px',
  fontWeight: 500,
  borderRadius: '4px',
  '&:not(:last-child)': {
    marginBottom: '6px',
  },
  '&.Mui-selected': {
    backgroundColor: theme.customColors.menuItem,
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.customColors.menuItem,
  },
  '&.Mui-selected, &.Mui-selected:hover, &.Mui-focusVisible, &[aria-selected="true"], &[data-focus="true"], &:hover':
    {
      backgroundColor: `${theme.customColors.menuItem} !important`,
    },
}));
